import { isEqual } from 'date-fns';
import { ContactSuggestion, HighlightableField } from '../types';
import { normalizeAiContactDataToContact } from './mappers';

export const highlightContactField = (
  sellerSuggestion: ContactSuggestion,
  field: HighlightableField | 'residence.normalizedAddress',
) => {
  if (sellerSuggestion.contact === undefined) return undefined;

  const normalizedSuggestion = normalizeAiContactDataToContact(sellerSuggestion.suggestion);

  if (field === 'residence.normalizedAddress') {
    return normalizedSuggestion.residence?.normalizedAddress !== sellerSuggestion.contact.residence?.normalizedAddress
      ? 'critical.default.low'
      : undefined;
  }
  if (field === 'birthday') {
    return !isEqual(new Date(normalizedSuggestion.birthday!), new Date(sellerSuggestion.contact.birthday!))
      ? 'critical.default.low'
      : undefined;
  }

  return normalizedSuggestion[field] !== sellerSuggestion.contact[field]
    ? 'critical.default.low'
    : undefined;
};
